import { render, staticRenderFns } from "./DriverFormDetail.vue?vue&type=template&id=909097e2&scoped=true&"
import script from "./DriverFormDetail.vue?vue&type=script&lang=js&"
export * from "./DriverFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./DriverFormDetail.vue?vue&type=style&index=0&id=909097e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909097e2",
  null
  
)

export default component.exports